import { render, staticRenderFns } from "./PhuConfiguration.vue?vue&type=template&id=3a585fc0&scoped=true"
import script from "./PhuConfiguration.vue?vue&type=script&lang=js"
export * from "./PhuConfiguration.vue?vue&type=script&lang=js"
import style0 from "./PhuConfiguration.vue?vue&type=style&index=0&id=3a585fc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a585fc0",
  null
  
)

export default component.exports